import { render, staticRenderFns } from "./InterfaceLoading.vue?vue&type=template&id=0fa185c3&scoped=true&"
import script from "./InterfaceLoading.vue?vue&type=script&lang=js&"
export * from "./InterfaceLoading.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceLoading.vue?vue&type=style&index=0&id=0fa185c3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa185c3",
  null
  
)

export default component.exports